import { Box, Button, Stack, Typography } from '@mui/material'
import ErrorImage from 'components/images/500Image.png'
import { useNavigate } from 'react-router-dom'
import classes from './styles.module.scss'

const InternalServer = () => {
  const navigate = useNavigate()
  const handleBack = () => {
    navigate('/admin/interface')
    window.location.reload()
  }

  return (
    <Stack className={classes.root}>
      <Box className={classes.container_header}>
        <Stack className={classes.content}>
          <Stack width="100%" justifyContent="center" alignItems="center">
            <img
              src={ErrorImage}
              alt="No img"
              style={{
                width: '100%',
                height: 'auto',
              }}
            />
            <Typography className={classes.txtNotFound}>
              Internal Server Error
            </Typography>
            <Typography className={classes.txtContent}>
              We are currently working on improving our product to provide a
              better experience for our users.
            </Typography>
            <Stack justifyContent="center" alignItems="center">
              <Button className={classes.btnBackPage} onClick={handleBack}>
                Go back
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Stack>
  )
}

export default InternalServer
